/* no babel so we have to use old js syntax */
import fixSidescrollerNextAndPrev from "./2020/_fix-sidescroller_next-and-prev";
import scrollToHash from "./2020/_scrollToHash";
import {sameHeight} from "./2020/_sameHeight";


window.Popper = require('popper.js');
require('bootstrap');

//import "@fontsource/oswald/latin.css";
//import "@fontsource/source-sans-pro/latin.css";
import "@fontsource/roboto/latin.css";

;$(function() {
  fixSidescrollerNextAndPrev();
  scrollToHash();

  // navigation
  var $hamburger = $(".hamburger");
  $hamburger.on("click", function(e) {
    $hamburger.toggleClass("is-active");
  });
  $('.js-navi-close').click(function() {
    $(".hamburger").click();
  });

  sameHeight([
    document.querySelectorAll('#_unsere-benefits .row-boxes > div')[0],
    document.querySelectorAll('#_unsere-benefits .row-boxes > div')[1],
    document.querySelectorAll('#_unsere-benefits .row-boxes > div')[2],
    document.querySelectorAll('#_unsere-benefits .row-boxes > div')[3],
    document.querySelectorAll('#_unsere-benefits .row-boxes > div')[4],
    document.querySelectorAll('#_unsere-benefits .row-boxes > div')[5],
  ], 'max');
});

/*
// Find all .dialog elements and prevent default click action
$('.dialog').on('click', function(event) {
  // The element has a second class called "dialog-" followed by a number. Get its name
  var dialogClass = $(this).attr('class').split(' ').find(function(c) {
    return c.startsWith('dialog-');
  });
  // There is a dialog element with data-dialog="dialogClass". Open it
  var dialog = $('[data-dialog="' + dialogClass + '"]');
  console.log(dialog);
  if (dialog.length) {
    event.preventDefault();
    // Open the dialog
    dialog[0].showModal();
  } else {
  }
});
*/



//////////////////
// WEBPACK FOOTER
// ./js/theme.js
// module id = 2
// module chunks = 0